/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

const moduleName = 'core';
const componentName = 'avi-fault-alert-modal';
const prefix = `${moduleName}.${componentName}`;

export const headerText = `${prefix}.headerText`;
export const alertMessage = `${prefix}.alertMessage`;
export const headerTitle = `${prefix}.headerTitle`;

export const ENGLISH = {
    [headerText]: 'Error Details',
    [alertMessage]: 'Controller exceeded single node limits for these objects',
    [headerTitle]: 'Header',
};
